import React, { Fragment, useState, useEffect, memo } from 'react'
import { Col, Container, Row, Card, CardBody } from 'reactstrap';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle, faEnvelope, faMobile, faMarker, faGlobeAmericas, faEdit } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import { calculateAgeParse } from '../../../Utils/Patient';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';
import UpdatePatient from '../../EditPatient/components/UpdatePatient';

const no_op = () => {};
const PatientBasicInfo = ({ id_patient = '0', setPatientTop = no_op }) => {
    const [patient, setPatient] = useState(null);
    const [editPatient, setEditPatient] = useState(false);

    useEffect(() => {
        if (id_patient !== null && id_patient !== undefined) {
            loadSearchPatient();
        }
    }, [])

    useEffect(() => {
        loadSearchPatient();
    }, [editPatient])


    const loadSearchPatient = async () => {
        let dataSend = {
            num_documento: parseInt(id_patient)
        }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                if (data.existe) {
                    setPatient(data.contenido[0])
                    setPatientTop(data.contenido[0])
                } else {
                    setPatient(null);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
    return (
        <Fragment>
            <Col md={12} lg={12} xl={12} xs={12}>
                <Card>
                    <CardBody className='card-body-patient-profile' style={{ padding: '2em' }}>
                        {
                            patient &&
                            <Fragment>
                                <div className='card-body-wraper'>
                                    <div className='card-basic-info'>
                                        <div>
                                            <FontAwesomeIcon className='avatar-icon' style={{ width: '5em', height: '5em' }} icon={faUserCircle} />
                                        </div>
                                        <div>
                                            <h4><b>{patient.nombres + ' ' + patient.apellido1 + ' ' + patient.apellido2}</b></h4>
                                        </div>
                                        <div>
                                            <FontAwesomeIcon className='contact-icon' icon={faMobile} /> <span>{patient.telefono1}</span>
                                            <FontAwesomeIcon className='contact-icon' icon={faEnvelope} /> <span>{patient.correo}</span>
                                        </div>
                                        <div>
                                            <FontAwesomeIcon className='contact-icon' icon={faGlobeAmericas} /> <span>{patient.direccion.direccion}</span>
                                        </div>
                                    </div>
                                    <div className='v-line'>
                                        <hr></hr>
                                    </div>
                                    <div style={{ paddingBottom: '1em', justifySelf: 'flex-start' }}>
                                        <div className='line-info' style={{ margin: '0.5em 1em' }}>
                                            <div><p><b>TIPO DE DOCUMENTO: </b> {patient.tip_documento}</p></div>
                                        </div>
                                        <div className='line-info' style={{ margin: '0.5em 1em' }}>
                                            <div><p><b>NÚMERO DE DOCUMENTO: </b> {patient.num_documento}</p></div>
                                        </div>
                                        <div className='line-info' style={{ margin: '0.5em 1em' }}>
                                            <div><p><b>FECHA DE NACIMIENTO: </b>{moment(patient.fec_nacimiento).format('DD-MM-YYYY')}</p></div>
                                        </div>
                                        <div className='line-info' style={{ margin: '0.5em 1em' }}>
                                            <div><p><b>EDAD: </b>{calculateAgeParse(patient.fec_nacimiento)}</p></div>
                                        </div>
                                        <div className='line-info' style={{ margin: '0.5em 1em' }}>
                                            <div><p><b>SEXO: </b>{patient.sexo}</p></div>
                                        </div>
                                        <div className='line-info' style={{ margin: '0.5em 1em' }}>
                                            <div><p><b>GRUPO SANGUINEO: </b> {patient.tipo_sangre}</p></div>
                                        </div>
                                        <div className='line-info' style={{ margin: '0.5em 1em' }}>
                                            <div><p><b>ESTADO VITAL</b> {patient.estado_vital}</p></div>
                                        </div>

                                    </div>
                                    {<div>
                                        <Tooltip
                                            title="Editar Paciente"
                                            className='tooltip-patient-profile'
                                        >
                                            <IconButton
                                                aria-label="upload picture"
                                                component="span"
                                                onClick={() => {
                                                    setEditPatient(true);
                                                }}
                                            >
                                                <FontAwesomeIcon className='contact-icon' icon={faEdit} style={{ width: '0.8em' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </div>}
                                </div>

                            </Fragment>
                        }
                    </CardBody>
                </Card>
            </Col>
            {
                editPatient == true ?
                    <Fragment>
                        <Modal
                            open={editPatient}
                            onClose={() => {
                                setEditPatient(false);
                            }}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            style={{ zIndex: 1000 }}
                        >
                            <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '80%', width: '80%', margin: 10, overflowY: 'auto' }}>
                                <UpdatePatient patient={patient} setEditPatient={setEditPatient} />
                            </div>
                        </Modal>
                    </Fragment>
                    : null
            }
        </Fragment>
    )
}

export default memo(PatientBasicInfo)